import { FEATURE_FLAG_KEYS } from "../constants/featureFlags";

export const ASSISTANT_UNAVAILABLE_MESSAGE =
  "O assistente está temporariamente indisponível para esta ação. Tente novamente mais tarde ou continue pelo fluxo normal do sistema.";

const ASSISTANT_DEFAULT_MODEL = "meta/muse-spark-1.3";
// Override via ASSISTANT_MODEL env in the Convex deployment using a provider/model ID.

export const ASSISTANT_LIMITS = {
  maxToolSteps: 4,
  totalTimeoutMs: 30_000,
  maxSearchTextLength: 80,
  perUserWindowMs: 60_000,
  perUserMaxRequests: 10,
  perUserDailyWindowMs: 24 * 60 * 60 * 1000,
  perUserDailyMaxRequests: 50,
  perOrganizationWindowMs: 24 * 60 * 60 * 1000,
  perOrganizationMaxRequests: 100,
} as const;

export const ASSISTANT_DOMAIN_FLAG_KEYS = {
  producers: FEATURE_FLAG_KEYS.ASSISTANT_PRODUCERS,
  projects: FEATURE_FLAG_KEYS.ASSISTANT_PROJECTS,
  finance: FEATURE_FLAG_KEYS.ASSISTANT_FINANCE,
  crm: FEATURE_FLAG_KEYS.ASSISTANT_CRM,
  content: FEATURE_FLAG_KEYS.ASSISTANT_CONTENT,
  writeActions: FEATURE_FLAG_KEYS.ASSISTANT_WRITE_ACTIONS,
} as const;

export type AssistantDomainFlag = keyof typeof ASSISTANT_DOMAIN_FLAG_KEYS;

export type AssistantDomainFlags = Record<AssistantDomainFlag, boolean>;

/** Static fallback used only when Convex flags are unavailable (e.g. local tests). */
const ASSISTANT_DOMAIN_FLAGS_FALLBACK: AssistantDomainFlags = {
  producers: true,
  projects: true,
  finance: false,
  crm: false,
  content: false,
  writeActions: false,
};

export function isAssistantDomainEnabled(
  domain: AssistantDomainFlag,
  resolved?: Partial<AssistantDomainFlags>,
) {
  if (resolved && domain in resolved && resolved[domain] !== undefined) {
    return resolved[domain] as boolean;
  }

  return ASSISTANT_DOMAIN_FLAGS_FALLBACK[domain];
}

export function isAssistantEnabled() {
  return process.env.ASSISTANT_ENABLED === "true";
}

/** Client-side kill switch mirroring ASSISTANT_ENABLED. Unset defers to Convex flags. */
export function isAssistantClientEnabled() {
  const value = process.env.NEXT_PUBLIC_ASSISTANT_ENABLED;
  if (value === undefined) {
    return true;
  }

  return value === "true";
}

export function getAssistantModel() {
  return process.env.ASSISTANT_MODEL?.trim() || ASSISTANT_DEFAULT_MODEL;
}

export { FEATURE_FLAG_KEYS };
